export default __webpack_public_path__ + "static/media/noha1.15077b18.jpeg";